import React, { useEffect, useState } from 'react';
import skillbridgethumb from '../../Assets/skillbrigdge.png'
import { CalenderIcon } from '../../Assets/Icons';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import CustomDateRangePicker from '../DateRangePicker';
import { convertStringToISODate } from '../../Utils/general';
import { setUpdateApplication } from '../../Store/slice/subscriptionSlice';

const ApplicationList = () => {
    const dispatch = useDispatch();
    const { checkedApplication, dateRange } = useSelector(state => state.subscriptionSlice);
    const [list, setList] = useState([]);

    useEffect(() => {
        setList(checkedApplication);
    }, [checkedApplication, dateRange]);

    const handleUpdateDateRange = (dates, id) => {
        let application = list.map((item) => ({
            ...item,
            dates: item.id === id ? dates ? dates : [null, null] : item.dates
        }));
        dispatch(setUpdateApplication({ data: application }));
    }

    const handleUpdateAmount = (value, id) => {
        if(/^[0-9]*$/.test(value)){
            let application = list.map((item) => ({
                ...item,
                amount: item.id === id ? value : item.amount
            }));
            dispatch(setUpdateApplication({ data: application }));
        }
    }

    return (
        <>
            <h5>Application</h5>
            <p>Select the XR Module you want to assign to a group, user, and role</p>

            <div className='row'>
                {list.map((item, index) => {
                    return (
                        <div key={item.id} className="validity-application-list">

                            <div className="validitythumb col-md-7">
                                <img src={item.icon} alt="" style={{ height: "40px", weight: "100px" }} />
                                <div>
                                    <h5> {item.title} </h5>
                                    <p> {item.description} </p>
                                </div>
                            </div>

                            <div className="col-md-2">
                                <input type="text" value={item.amount} onChange={(e) => handleUpdateAmount(e.target.value, item.id)} />
                            </div>

                            <div className="col-md-3">
                                <CustomDateRangePicker dateRange={[convertStringToISODate(item?.dates[0]), convertStringToISODate(item?.dates[1])]} setDateRange={(data) => handleUpdateDateRange(data, item.id)} />

                            </div>
                        </div>
                    )
                })}
            </div>


        </>
    )
}

export default ApplicationList